import styled from 'styled-components';
import { ImageUtils } from '../../../utils/ImageUtils';
import { mobileQuery } from '../../../utils';

export const OnlineInfo = () => {
  return (
    <Container>
      <Item>
        <TitleContainer>
          <NumberIcon src={ImageUtils.NumberIcon1}></NumberIcon>
          <Title>새틀라이트 참가 하기</Title>
        </TitleContainer>
        <Content>
          <ContentImg1 src={ImageUtils.GuideImg1} />
          <ContentText>‘새틀라이트’ 라벨이 달린 토너먼트에 참여해주세요!</ContentText>
        </Content>
        <WaringContainer>
          <WaringText>
            여러 장의 티켓을 <span>복수 획득</span> 할 수 있습니다.
          </WaringText>
        </WaringContainer>
      </Item>

      <Item>
        <TitleContainer>
          <NumberIcon src={ImageUtils.NumberIcon2}></NumberIcon>
          <Title>메인 이벤트 참가를 위한 개인 정보 동의</Title>
        </TitleContainer>
        <Content>
          <ContentImg2 src={ImageUtils.GuideImg2} />
          <ContentText>
            새틀라이트 참가를 위한 개인정보 3자 제공 동의 후 골드 또는 티켓을 내고 참가해주세요!
          </ContentText>
        </Content>
        <WaringContainer>
          <WaringText>동의하지 않는 경우 새틀라이트에 참가할 수 없습니다.</WaringText>
        </WaringContainer>
      </Item>

      <Item>
        <TitleContainer>
          <NumberIcon src={ImageUtils.NumberIcon3}></NumberIcon>
          <Title>새틀라이트 입상하고 메인 이벤트 티켓 획득하기</Title>
        </TitleContainer>

        <CenterContent style={{ marginBottom: 11.5 }}>
          <ContentImg3 src={ImageUtils.GuideImg3_1} />
          <ContentText>
            <ContentBold>새틀 for 새틀</ContentBold>
            {` `}
            <ContentSemiBold>토너먼트</ContentSemiBold>
            <br /> 인더머니 순위를 기록하고 온라인 새틀라이트 티켓을 획득해주세요!
          </ContentText>
        </CenterContent>

        <CenterContent>
          <ContentImg3 src={ImageUtils.GuideImg3} />
          <ContentText>
            <ContentBold>새틀라이트</ContentBold>
            {` `} <ContentSemiBold>12 to 1 </ContentSemiBold> <br />
            인더머니 순위를 기록하고 우승자 아바타와 오프라인 메인 이벤트 티켓을 획득해주세요!
          </ContentText>
        </CenterContent>

        <WaringContainer>
          <WaringText>
            새틀 for 새틀에서 획득한 티켓은 온라인 새틀라이트에 참가할 때 사용할 수 있으며, 주말에는
            프리롤로 진행됩니다.
          </WaringText>
          <WaringText>
            새틀라이트 최대 엔트리 수는 남은 티켓에 따라 변경됩니다. 남은 최대 엔트리 수에 따라
            엔트리가 불가능 할 수 있습니다.
          </WaringText>
        </WaringContainer>
      </Item>

      <Item>
        <TitleContainer>
          <NumberIcon src={ImageUtils.NumberIcon4}></NumberIcon>
          <Title>메인 이벤트 참가를 위한 티켓 확인 및 선수 등록</Title>
        </TitleContainer>
        <Content>
          <ContentImg4 src={ImageUtils.GuideImg4} />
          <ContentText>
            메인 이벤트 티켓을 획득했다면 참가 티켓 번호를 확인 후 PFGT 선수 등록을 진행하여 메인
            이벤트에 참가해주세요!
          </ContentText>
        </Content>
      </Item>
    </Container>
  );
};

const Container = styled.div``;
const Item = styled.div`
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(112, 112, 112, 0.5);

  &:last-child {
    border-bottom: none;
  }

  ${mobileQuery} {
    padding-bottom: 13px;
    margin-bottom: 13px;
  }
`;
const TitleContainer = styled.div`
  margin-bottom: 10px;
  ${mobileQuery} {
    margin-bottom: 4px;
  }
`;

const Title = styled.h3`
  color: #fff;
  font-size: 22px;
  font-weight: 400;
  letter-spacing: -0.44px;

  ${mobileQuery} {
    font-size: 16px;
    line-height: 18px;
    margin-bottom: 6px;
  }
`;

const ContentText = styled.h4`
  color: rgba(255, 255, 255, 0.6);
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 34px; /* 170% */
  letter-spacing: -0.4px;

  strong {
    font-weight: 500;
    color: white;
  }

  span {
    color: white;
    text-decoration: underline;
  }

  ${mobileQuery} {
    font-size: 16px;
    line-height: 22px;
  }
`;

const ContentBold = styled.i`
  color: #fd4896;
  font-style: normal;
  font-weight: bold;
`;

const ContentSemiBold = styled.i`
  font-weight: bold;
  font-style: normal;
`;

const NumberIcon = styled.img`
  width: 28px;
  height: 28px;
  margin-right: 8px;
  float: left;
  margin-top: 4px;

  ${mobileQuery} {
    margin-top: 1px;
    margin-right: 4px;
    width: 18px;
    height: 18px;
  }
`;
const ContentImg = styled.img`
  margin-right: 13px;

  ${mobileQuery} {
    margin-right: 9px;
  }
`;

const ContentImg1 = styled(ContentImg)`
  width: 239px;
  flex-shrink: 0;
  ${mobileQuery} {
    width: 160px;
  }
`;

const ContentImg2 = styled(ContentImg)`
  width: 226px;
  ${mobileQuery} {
    width: 160px;
  }
`;

const ContentImg3 = styled(ContentImg)`
  width: 257px;
  padding-left: 12px;
  padding-right: 12px;
  ${mobileQuery} {
    width: 160px;
  }
`;

const ContentImg4 = styled(ContentImg)`
  width: 226px;
  ${mobileQuery} {
    width: 161px;
  }
`;

const Content = styled.div`
  overflow: hidden;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
`;

const CenterContent = styled(Content)`
  align-items: center;
`;

const WaringContainer = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  padding-left: 30px;
  margin-top: 10px;

  ${mobileQuery} {
    padding-left: 10px;
  }
`;

const WaringText = styled.li`
  color: #8e8e8e;

  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: -0.96px;
  position: relative;

  &:after {
    content: '';
    width: 6px;
    height: 6px;
    background: #8e8e8e;
    border-radius: 50%;
    position: absolute;
    left: -20px;
    top: 10px;
  }

  ${mobileQuery} {
    font-size: 14px;
    line-height: 22px;

    &:after {
      width: 4px;
      height: 4px;
      left: -8px;
      top: 9px;
    }
  }

  span {
    color: white;
    text-decoration: underline;
  }
`;
